<div class="work-application-form-container">
  <form [formGroup]="workApplicationForm" (ngSubmit)="onSubmit()">

    <!-- 第一區塊：基本資訊 -->
    <div class="panel">
      <div class="panel-header">
        <h3><i class="fas fa-info-circle"></i> 基本資訊</h3>
        <button type="button" class="collapse-btn" (click)="togglePanel('basicInfo')">
          <i class="fas" [class.fa-chevron-up]="panelStates.basicInfo" [class.fa-chevron-down]="!panelStates.basicInfo"></i>
        </button>
      </div>
      <div class="panel-content" [class.collapsed]="!panelStates.basicInfo">
        <!-- 第一行 -->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>申請日期：<span class="required">*</span></label>
              <div class="date-input-group">
                <input type="number" class="form-control" formControlName="year" min="1911" max="9999">
                <span class="date-separator">年</span>
                <input type="number" class="form-control" formControlName="month" min="1" max="12">
                <span class="date-separator">月</span>
                <input type="number" class="form-control" formControlName="day" min="1" max="31">
                <span class="date-separator">日</span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>作業名稱：<span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="workName" placeholder="請輸入作業名稱">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>表單編號：</label>
              <input type="text" class="form-control" formControlName="formNumber" readonly>
            </div>
          </div>
        </div>

        <!-- 第二行 -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>請購部門：<span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="requestDepartment" placeholder="請輸入請購部門">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>請購部門負責人/連絡電話：<span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="requestContactInfo" placeholder="請輸入負責人姓名及電話">
            </div>
          </div>
        </div>

        <!-- 第三行 -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>選擇承攬商：<span class="required">*</span></label>
              <select class="form-control" formControlName="contractorId" (change)="onContractorSelectChange($event)">
                <option value="">請選擇承攬商</option>
                <option *ngFor="let contractor of contractors" [value]="contractor.id">
                  {{ contractor.companyName }} ({{ contractor.uniformNumber }})
                </option>
              </select>
              <div *ngIf="isLoadingContractors" class="loading-text">
                <i class="fas fa-spinner fa-spin"></i> 載入承攬商列表中...
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>統一編號：</label>
              <input type="text" class="form-control" formControlName="uniformNumber" readonly>
            </div>
          </div>
        </div>

        <!-- 承攬商詳細資訊 -->
        <div *ngIf="selectedContractor" class="contractor-info-panel">
          <h5><i class="fas fa-building"></i> 承攬商詳細資訊</h5>
          <div class="row">
            <div class="col-md-6">
              <p><strong>負責人：</strong>{{ selectedContractor.responsiblePerson }}</p>
              <p><strong>聯絡電話：</strong>{{ selectedContractor.contactPhone }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>安全管理人員：</strong>{{ selectedContractor.safetyOfficer }}</p>
              <p><strong>安管人員電話：</strong>{{ selectedContractor.safetyOfficerPhone }}</p>
            </div>
          </div>
        </div>


      </div>
    </div>

    <!-- 第二區塊：作業內容 -->
    <div class="panel">
      <div class="panel-header">
        <h3><i class="fas fa-tasks"></i> 作業內容</h3>
        <button type="button" class="collapse-btn" (click)="togglePanel('workContent')">
          <i class="fas" [class.fa-chevron-up]="panelStates.workContent" [class.fa-chevron-down]="!panelStates.workContent"></i>
        </button>
      </div>


      <div class="panel-content" [class.collapsed]="!panelStates.workContent">

           <!-- 作業期間 -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>作業期間：<span class="required">*</span></label>
              <div class="date-range-group">
                <input type="number" class="form-control" formControlName="startYear" min="1911" max="9999">
                <span class="date-separator">年</span>
                <input type="number" class="form-control" formControlName="startMonth" min="1" max="12">
                <span class="date-separator">月</span>
                <input type="number" class="form-control" formControlName="startDay" min="1" max="31">
                <span class="date-separator">日</span>
                <input type="number" class="form-control" formControlName="startHour" min="0" max="23">
                <span class="date-separator">時</span>
                <span class="date-range-separator">至</span>
                <input type="number" class="form-control" formControlName="endYear" min="1911" max="9999">
                <span class="date-separator">年</span>
                <input type="number" class="form-control" formControlName="endMonth" min="1" max="12">
                <span class="date-separator">月</span>
                <input type="number" class="form-control" formControlName="endDay" min="1" max="31">
                <span class="date-separator">日</span>
                <input type="number" class="form-control" formControlName="endHour" min="0" max="23">
                <span class="date-separator">時</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 作業區域與承攬單位 -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>作業區域：<span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="workLocation" placeholder="請輸入作業區域">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>承攬單位：<span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="contractingUnit" readonly>
            </div>
          </div>
        </div>

        <!-- 作業內容 -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>作業內容：<span class="required">*</span></label>
              <textarea class="form-control" rows="3" formControlName="workContent" placeholder="請詳細描述作業內容"></textarea>
            </div>
          </div>
        </div>

        <!-- 作業類別 -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>作業類別：</label>
              <div class="checkbox-container">
                <div class="checkbox-grid">
                  <div *ngFor="let workType of workTypes" class="checkbox-item">
                    <input type="checkbox" [id]="workType.id" [formControlName]="workType.id">
                    <label [for]="workType.id">{{ workType.label }}</label>
                  </div>
                </div>
                <div class="form-group mt-3" *ngIf="workApplicationForm.get('workType14')?.value">
                  <label>其他作業內容說明：</label>
                  <textarea class="form-control" rows="2" formControlName="otherWorkContent" placeholder="若選擇其他作業，請詳細說明"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>        <!-- 特殊作業 -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>特殊作業：</label>
              <div class="special-work-container">
                <!-- 特殊作業選項 - 使用更緊湊的表格式排版 -->
                <div class="special-work-grid">
                  <div class="special-work-item">
                    <label class="special-work-label">※動火作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="hotWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="hotWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※吊掛作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="suspendedWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="suspendedWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※局限空間作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="confinedSpaceWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="confinedSpaceWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※有機溶劑作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="organicSolventWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="organicSolventWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※高架作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="highAltitudeWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="highAltitudeWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※特殊作業：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="specialWork" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="specialWork" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>

                  <div class="special-work-item">
                    <label class="special-work-label">※廠務工程部人員協同監工：</label>
                    <div class="radio-inline-group">
                      <label class="radio-inline">
                        <input type="radio" formControlName="needEngineer" [value]="true"> 需要
                      </label>
                      <label class="radio-inline">
                        <input type="radio" formControlName="needEngineer" [value]="false"> 不需要
                      </label>
                    </div>
                  </div>
                </div>

                <!-- 電器作業 - 單獨一行因為有額外輸入欄位 -->
                <div class="special-work-item electrical-work-section">
                  <label class="special-work-label">※電器作業：</label>
                  <div class="radio-inline-group">
                    <label class="radio-inline">
                      <input type="radio" formControlName="electricalWork" [value]="true"> 需要
                    </label>
                    <label class="radio-inline">
                      <input type="radio" formControlName="electricalWork" [value]="false"> 不需要
                    </label>
                  </div>

                  <!-- 電器作業詳細資訊 -->
                  <div *ngIf="workApplicationForm.get('electricalWork')?.value" class="electrical-details mt-2">
                    <div class="electrical-input-group">
                      <span class="input-label">用電設備需求：</span>
                      <input type="text" class="form-control input-sm" formControlName="powerRequirements" placeholder="功率">
                      <span class="unit">KW</span>
                      <input type="text" class="form-control input-sm" formControlName="voltage" placeholder="電壓">
                      <span class="unit">V</span>
                      <input type="text" class="form-control input-sm" formControlName="phase" placeholder="相數">
                      <span class="unit">φ</span>
                      <input type="text" class="form-control input-sm" formControlName="ampere" placeholder="安培">
                      <span class="unit">A</span>
                    </div>
                  </div>
                </div>

                <!-- 備註 -->
                <div class="special-work-note">
                  <small class="text-muted">備註：填寫此需求表若無回簽時，承攬商不得進入施工區域</small>
                </div>

                <!-- 使用工具 -->
                <div class="tools-section">
                  <label class="section-label">使用工具：</label>
                  <div class="checkbox-compact-grid">
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool1"> 1.電焊
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool2"> 2.電動機
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool3"> 3.電熱器
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool4"> 4.電鑽
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool5"> 5.噴漆
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool6"> 6.氣氛
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool7"> 7.砂輪機
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool8"> 8.塑膠焊
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="tool9"> 9.其他
                    </label>
                  </div>
                  <div class="mt-2" *ngIf="workApplicationForm.get('tool9')?.value">
                    <input type="text" class="form-control form-control-sm" formControlName="otherTools" placeholder="請說明其他使用工具">
                  </div>
                </div>

                <!-- 工作內容 -->
                <div class="work-content-section">
                  <label class="section-label">工作內容：</label>
                  <div class="checkbox-compact-grid">
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType1"> 1.拆(配)線
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType2"> 2.新裝/拆除
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType3"> 3.配管
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType4"> 4.維修保養
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType5"> 5.油漆/防水
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType6"> 6.清潔
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType7"> 7.消防
                    </label>
                    <label class="checkbox-compact">
                      <input type="checkbox" formControlName="workContentType8"> 8.其他
                    </label>
                  </div>
                  <div class="mt-2" *ngIf="workApplicationForm.get('workContentType8')?.value">
                    <input type="text" class="form-control form-control-sm" formControlName="otherWorkContentType" placeholder="請說明其他工作內容">
                  </div>
                </div>

                <!-- 承攬商簽章區域 -->
                <div class="contractor-signature-section">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>主承攬商現場負責人：</label>
                        <app-form-signature
                          formControlName="contractorResponsiblePerson"
                          [width]="280"
                          [height]="120">
                        </app-form-signature>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>主承攬商工安人員：</label>
                        <app-form-signature
                          formControlName="contractorSafetyOfficer"
                          [width]="280"
                          [height]="120">
                        </app-form-signature>
                      </div>
                    </div>
                  </div>
                  <div class="note-text">
                    備註：以上由承攬商現場
                  </div>
                </div>

                <!-- 電器允許方式 -->
                <div class="electrical-permission-section">
                  <label class="section-label">電器允許方式：</label>
                  <div class="checkbox-list">
                    <div class="checkbox-item">
                      <label class="checkbox-with-input">
                        <input type="checkbox" formControlName="electricalPermissionType1">
                        1.進行
                        <input type="text" class="form-control inline-input" formControlName="electricalFloorNumber" placeholder="樓層">
                        樓層停電
                      </label>
                    </div>
                    <div class="checkbox-item">
                      <label class="checkbox-simple">
                        <input type="checkbox" formControlName="electricalPermissionType2"> 2.需配專線
                      </label>
                    </div>
                    <div class="checkbox-item">
                      <label class="checkbox-simple">
                        <input type="checkbox" formControlName="electricalPermissionType3"> 3.指定不斷電系統插座
                      </label>
                    </div>
                    <div class="checkbox-item">
                      <label class="checkbox-with-input">
                        <input type="checkbox" formControlName="electricalPermissionType4">
                        4.一般插座
                        <input type="text" class="form-control inline-input" formControlName="electricalVoltage" placeholder="電壓">
                        V
                      </label>
                    </div>
                    <div class="checkbox-item">
                      <label class="checkbox-simple">
                        <input type="checkbox" formControlName="electricalPermissionType5"> 5.指定電器箱
                      </label>
                    </div>
                    <div class="checkbox-item">
                      <label class="checkbox-with-input">
                        <input type="checkbox" formControlName="electricalPermissionType6">
                        6.其他
                        <input type="text" class="form-control inline-input-wide" formControlName="electricalOtherDescription" placeholder="請說明">
                      </label>
                    </div>
                  </div>
                </div>

                <!-- 廠務工程部區域 -->
                <div class="department-section">
                  <div class="department-suggestions">
                    <label>廠務工程部建議意見：</label>
                    <textarea class="form-control" formControlName="engineeringDeptSuggestions" rows="3" placeholder="請輸入建議意見"></textarea>
                  </div>
                  <div class="signature-row">
                    <div class="signature-group">
                      <label>廠務工程部人員：</label>
                      <app-form-signature
                        formControlName="engineeringDeptStaff"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                    <div class="signature-group">
                      <label>總務或廠務工程部主管：</label>
                      <app-form-signature
                        formControlName="engineeringDeptManager"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                    <div class="signature-group">
                      <label>廠務工程部監工人員：</label>
                      <app-form-signature
                        formControlName="engineeringDeptSupervisor"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                  </div>
                  <div class="note-text">
                    備註：廠區用電部分申請為廠務工程部，請確實告知需使用之插座或電器。
                  </div>
                </div>

                <!-- 環安衛生安部門區域 -->
                <div class="department-section">
                  <div class="department-suggestions">
                    <label>環安衛生安部門建議意見：</label>
                    <textarea class="form-control" formControlName="ehsDeptSuggestions" rows="3" placeholder="請輸入建議意見"></textarea>
                  </div>
                  <div class="signature-row">
                    <div class="signature-group">
                      <label>環安衛生安部人員：</label>
                      <app-form-signature
                        formControlName="ehsDeptStaff"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                    <div class="signature-group">
                      <label>環安衛生安部主管：</label>
                      <app-form-signature
                        formControlName="ehsDeptManager"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                  </div>
                </div>

                <!-- 請購施工部門區域 -->
                <div class="department-section">
                  <div class="department-suggestions">
                    <label>請購施工部門現場施工期間建議意見：</label>
                    <textarea class="form-control" formControlName="constructionDeptSuggestions" rows="3" placeholder="請輸入建議意見"></textarea>
                  </div>
                  <div class="signature-row">
                    <div class="signature-group">
                      <label>施工部門人員：</label>
                      <app-form-signature
                        formControlName="constructionDeptStaff"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                    <div class="signature-group">
                      <label>施工部門主管：</label>
                      <app-form-signature
                        formControlName="constructionDeptManager"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                    <div class="signature-group">
                      <label>部門現場監工人員：</label>
                      <app-form-signature
                        formControlName="constructionDeptSupervisor"
                        [width]="250"
                        [height]="100">
                      </app-form-signature>
                    </div>
                  </div>
                  <div class="note-text">
                    備註：以上由工程請購部門現場
                  </div>
                </div>

                <!-- 完工後備註 -->
                <div class="completion-note">
                  <p class="note-text">
                    施工完畢後請將此申請單交回環安衛生安部，施工申請單留存二年
                  </p>
                  <div class="final-signature-row">
                    <div class="final-signature-group">
                      <label>環安衛生安部人員：</label>
                      <app-form-signature
                        formControlName="finalEhsDeptStaff"
                        [width]="200"
                        [height]="80">
                      </app-form-signature>
                    </div>
                    <div class="final-signature-group">
                      <label>環安衛生安部主管：</label>
                      <app-form-signature
                        formControlName="finalEhsDeptManager"
                        [width]="200"
                        [height]="80">
                      </app-form-signature>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 人員選擇區塊 -->
    <div class="panel">
      <div class="panel-header">
        <h3><i class="fas fa-users"></i> 選擇人員</h3>
        <button type="button" class="collapse-btn" (click)="togglePanel('personnelSelection')">
          <i class="fas" [class.fa-chevron-up]="panelStates.personnelSelection" [class.fa-chevron-down]="!panelStates.personnelSelection"></i>
        </button>
      </div>
      <div class="panel-content" [class.collapsed]="!panelStates.personnelSelection">

        <!-- 提示訊息 -->
        <div *ngIf="!workApplicationForm.get('contractorId')?.value" class="alert alert-info">
          <i class="fas fa-info-circle"></i>
          請先在基本資訊區塊選擇承攬商，才能載入該承攬商的人員資料。
        </div>

        <!-- 載入中狀態 -->
        <div *ngIf="isLoadingPersonnel" class="loading-container">
          <i class="fas fa-spinner fa-spin"></i> 載入人員資料中...
        </div>

        <!-- 人員選擇區域 -->
        <div *ngIf="workApplicationForm.get('contractorId')?.value && !isLoadingPersonnel" class="personnel-selection-container">
          <div class="row">
            <!-- 左欄：可選人員列表 -->
            <div class="col-md-6">
              <div class="personnel-available">
                <div class="section-header">
                  <h6>可選人員 <small class="text-muted">(總計: {{availablePersonnel.length}}人)</small></h6>
                  <div class="section-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary"
                            (click)="selectAllPersonnel()"
                            [disabled]="filteredAvailablePersonnel.length === 0">
                      <i class="fas fa-check-double"></i> 全選
                    </button>
                  </div>
                </div>

                <!-- 搜尋框 -->
                <div class="search-container">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           [(ngModel)]="personnelSearchTerm"
                           [ngModelOptions]="{standalone: true}"
                           placeholder="搜尋姓名、身分證字號或電話"
                           (keyup.enter)="searchPersonnel()">
                    <!-- <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()" *ngIf="personnelSearchTerm">
                        <i class="fas fa-times"></i>
                      </button>
                    </div> -->
                  </div>
                </div>

                <!-- 人員列表 -->
                <div class="personnel-list" [style.max-height.px]="300">
                  <div *ngIf="filteredAvailablePersonnel.length === 0" class="no-personnel">
                    <i class="fas fa-user-slash"></i>
                    <p>{{ personnelSearchTerm ? '沒有符合搜尋條件的人員' : '暫無可選人員' }}</p>
                  </div>

                  <table class="table table-sm table-hover" *ngIf="filteredAvailablePersonnel.length > 0">
                    <thead>
                      <tr>
                        <th width="60">選擇</th>
                        <th>姓名</th>
                        <th>身分證字號</th>
                        <th>電話</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let person of filteredAvailablePersonnel">
                        <td>
                          <button type="button" class="btn btn-sm btn-outline-success"
                                  (click)="selectPerson(person)">
                            <i class="fas fa-plus"></i>
                          </button>
                        </td>
                        <td>{{ person.name }}</td>
                        <td>{{ person.idNumber }}</td>
                        <td>{{ person.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- 右欄：已選取人員列表 -->
            <div class="col-md-6">
              <div class="personnel-selected">
                <div class="section-header">
                  <h6>已選取人員 <small class="text-muted">(已選: {{selectedPersonnel.length}}人)</small></h6>
                  <div class="section-actions">
                    <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="clearAllSelected()"
                            [disabled]="selectedPersonnel.length === 0">
                      <i class="fas fa-times"></i> 清空
                    </button>
                  </div>
                </div>

                <!-- 已選人員列表 -->
                <div class="selected-list" [style.max-height.px]="300">
                  <div *ngIf="selectedPersonnel.length === 0" class="no-personnel">
                    <i class="fas fa-user-plus"></i>
                    <p>尚未選擇人員</p>
                  </div>

                  <div *ngFor="let person of selectedPersonnel" class="selected-person-item">
                    <div class="person-info">
                      <div class="person-name">{{ person.name }}</div>
                      <div class="person-details">
                        <small>{{ person.idNumber }} | {{ person.phone }}</small>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="removePerson(person)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三區塊：所需資料 -->
    <div class="panel">
      <div class="panel-header">
        <h3><i class="fas fa-file-alt"></i> 所需資料</h3>
        <button type="button" class="collapse-btn" (click)="togglePanel('requiredDocuments')">
          <i class="fas" [class.fa-chevron-up]="panelStates.requiredDocuments" [class.fa-chevron-down]="!panelStates.requiredDocuments"></i>
        </button>
      </div>
      <div class="panel-content" [class.collapsed]="!panelStates.requiredDocuments">
        <div class="panel-header-info">
         根據所選作業類別動態顯示所需文件
        </div>

        <!-- 使用新的表單資料卡片元件 -->
        <div class="form-data-cards-container">
          <app-form-data-card
            *ngFor="let config of formDataConfigs"
            [formid]="config.formid"
            [formTitle]="config.formTitle"
            [maxRecords]="config.maxRecords"
            [required]="config.required || false"
            (addData)="onAddFormData($event)"
            (viewList)="onViewFormDataList($event)"
            (viewDetail)="onViewFormDataDetail($event)">
          </app-form-data-card>
        </div>

        <div *ngIf="formDataConfigs.length === 0" class="no-documents">
          <i class="fas fa-info-circle"></i>
          <p>請選擇作業類別以顯示所需文件</p>
        </div>
      </div>
    </div>

    <!-- 第四區塊：簽核區域 -->
    <!-- <div class="panel">
      <div class="panel-header">
        <h3><i class="fas fa-signature"></i> 簽核區域</h3>
        <button type="button" class="collapse-btn" (click)="togglePanel('signatureArea')">
          <i class="fas" [class.fa-chevron-up]="panelStates.signatureArea" [class.fa-chevron-down]="!panelStates.signatureArea"></i>
        </button>
      </div>
      <div class="panel-content" [class.collapsed]="!panelStates.signatureArea">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>電源配置方式：</label>
              <form [formGroup]="powerRequestForm" class="power-config-form">
                <div class="checkbox-grid">
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType1" formControlName="powerType1">
                    <label for="powerType1">1. 110V 單相插座</label>
                  </div>
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType2" formControlName="powerType2">
                    <label for="powerType2">2. 220V 單相插座</label>
                  </div>
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType3" formControlName="powerType3">
                    <label for="powerType3">3. 220V 三相插座</label>
                  </div>
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType4" formControlName="powerType4">
                    <label for="powerType4">4. 380V 三相插座</label>
                  </div>
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType5" formControlName="powerType5">
                    <label for="powerType5">5. 臨時配電盤</label>
                  </div>
                  <div class="checkbox-item">
                    <input type="checkbox" id="powerType6" formControlName="powerType6">
                    <label for="powerType6">6. 其他</label>
                  </div>
                </div>
                <div class="form-group mt-3">
                  <label>其他電源需求說明：</label>
                  <textarea class="form-control" rows="2" formControlName="otherPowerType" placeholder="若選擇其他，請詳細說明電源需求"></textarea>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="signature-section">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>機房責任工程師簽章：</label>
                <app-form-signature
                  formControlName="engineerSignature"
                  [width]="300"
                  [height]="150">
                </app-form-signature>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>環安衛生管理人員簽章：</label>
                <app-form-signature
                  formControlName="safetyOfficerSignature"
                  [width]="300"
                  [height]="150">
                </app-form-signature>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>請購施工部門現場施工期間建議事項：</label>
                <textarea class="form-control" rows="4" formControlName="constructionSuggestions" placeholder="請填寫施工期間的建議事項"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>施工部門人員簽章：</label>
                <app-form-signature
                  formControlName="constructionStaffSignature"
                  [width]="300"
                  [height]="150">
                </app-form-signature>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 操作按鈕 -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        <i class="fas fa-times"></i> 取消
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="workApplicationForm.invalid">
        <i class="fas fa-save"></i> {{ isEditMode ? '更新' : '提交' }}申請
      </button>
    </div>
  </form>
</div>
